import {
  TNoteDB,
  TNoteUI,
  TCreateNoteUI,
  TCreateNoteDB,
  TUpdateNoteUI,
  TUpdateNoteDB,
} from 'data/types/notes.types';

export const noteConverter = {
  fromDb: (data: TNoteDB): TNoteUI => ({
    resourceId: data.resourceId,
    note: data.note,
    isPrivate: data.isPrivate,
    createdDate: data.createdDate,
    createdByName: data.createdByName,
    updatedDate: data.updatedDate,
    updatedByName: data.updatedByName,
    allowedOperation: data.allowedOperation,
  }),
};

export const createNoteConverter = {
  toDb: (data: TCreateNoteUI): TCreateNoteDB => ({
    note: data.note,
    id: data.id,
    entityType: data.entityType,
    isPrivate: data.isPrivate,
  }),
};

export const updateNoteConverter = {
  toDb: (data: TUpdateNoteUI): TUpdateNoteDB => ({
    note: data.note,
    isPrivate: data.isPrivate,
  }),
};
